import { render, staticRenderFns } from "./FundamentalFormDetail.vue?vue&type=template&id=4f70587e&scoped=true&"
import script from "./FundamentalFormDetail.vue?vue&type=script&lang=js&"
export * from "./FundamentalFormDetail.vue?vue&type=script&lang=js&"
import style0 from "./FundamentalFormDetail.vue?vue&type=style&index=0&id=4f70587e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f70587e",
  null
  
)

export default component.exports